module.exports = {
  "$id": "normalRegister",
  "type": "object",
  "title": "身份证注册",
  "properties": {
    "loginName": {
      "title": "用户名",
      "type": "string",
      "format": "loginName"
    },
    "password": {
      "title": "密码",
      "type": "string",
      "format": "newPassword"
    },
    "confirmPassword": {
      "title": "确认密码",
      "type": "string",
      "format": "newPassword",
      "const": {
        "$data": "1/password"
      }
    },
    "surname": {
      "title": "中文姓",
      "type": "string",
      "customValidate": "zhLastName"
    },
    "name": {
      "title": "中文名",
      "type": "string",
      "customValidate": "zhFirstName"
    },
    "certNo": {
      "title": "身份证号",
      "type": "string",
      "customValidate": "identityCard"
    },
    "phone": {
      "title": "手机号",
      "type": "string",
      "customValidate": "mobile"
    },
    "areaCode": {
      "title": "区位码",
      "type": "string"
    }
  },
  "required": [
    "loginName",
    "password",
    "confirmPassword",
    "surname",
    "name",
    "certNo",
    "phone"
  ],
  "errorMessage": {
    "loginName": {
      "message": "请输入用户名,长度6-40位",
      "required": "用户名不能为空"
    },
    "password": {
      "message": "请输入密码，密码要求8-15位，大小写字母、数字、特殊符号4种中的至少3种",
      "required": "密码不能为空"
    },
    "confirmPassword": {
      "message": "两次密码输入不一致！",
      "pattern": "请输入密码，密码要求8-15位，大小写字母、数字、特殊符号4种中的至少3种",
      "required": "请再次输入密码"
    },
    "surname": {
      "required": "中文姓不能为空"
    },
    "name": {
      "required": "中文名不能为空"
    },
    "certNo": {
      // "message": "身份证号码不正确",
      "required": "请输入身份证号码"
    },
    "phone": {
      "required": "手机号码不能为空"
    }
  }
}
